import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { ModalsEffects } from './modals.effects';
import { ModalsFacade } from './modals.facade';

@NgModule({
    declarations: [],
    imports: [EffectsModule.forFeature([ModalsEffects])],
    providers: [ModalsFacade],
})
export class ModalsStoreModule {}
